import { SurveyAnswer, SurveyAnswerValueRecord, SurveyVisibilityConditions } from "../interface"
import { ConditionsOperator, AnswerType } from "../constants"

export function compareConditions(
    visibilityConditions: SurveyVisibilityConditions[],
    answers: Record<string, SurveyAnswer>
): boolean {
    return visibilityConditions.every((c) => {
        const cValue = c.value.toLowerCase()

        switch (c.operator) {
            case ConditionsOperator.EQUALS:
                return answers[c.precondition_question_id]?.type === AnswerType.choices
                    ? (answers[c.precondition_question_id]?.value as SurveyAnswerValueRecord)[
                          cValue
                      ]
                    : answers[c.precondition_question_id]?.value === cValue
            case ConditionsOperator.IN: {
                const cValues = cValue.split(",")
                return answers[c.precondition_question_id]?.type === AnswerType.number
                    ? cValues.indexOf(String(answers[c.precondition_question_id]?.value)) > -1
                    : false
            }
            case ConditionsOperator.NOTEMPTY:
                return answers[c.precondition_question_id]?.value
            default:
                return false
        }
    })
}
